import React, { useState } from "react";
import moment from "moment";
import Loader from "../Common/Loader";
import { Link } from "react-router-dom";
import HeadToHeadService from "../../services/HeadToHeadService";
import H2HBattleList from "./H2HBattleList";
const H2hB = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [h2hBattleData, setH2hBattleData] = useState([]);
  const [roundDetails, setRoundDetails] = useState([]);
  const handleH2HShow = (id) => {
    HeadToHeadService.showGroupHeadToHeadRound(2, id).then((res) => {
      if (res.status === 200) {
        setH2hBattleData(res.data);
        setRoundDetails(res.roundDetails);
      }
    });
    setIsModalOpen(!isModalOpen);
  };

  return (
    <>
      <div className="table-wrap">
        {props.scheduleLoading && <Loader />}
        {!props.scheduleLoading && (
          <table className="main-table2 table innertable">
            <thead>
              <tr>
                <th scope="col">H2H</th>
                <th scope="col">Duration</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {props.getScheduleData &&
                props.getScheduleData.map((item, key) => (
                  <tr key={key}>
                    <td>Round {item?.round}</td>
                    <td>
                      {moment(item.start_date).format("MMM D")}-
                      {moment(item.end_date).format("MMM D")}
                    </td>

                    <td>
                      {item?.is_2generated && (
                        <Link
                          size="sm"
                          onClick={() => handleH2HShow(item?.id)}
                          className="more_link"
                          style={{
                            color: "white",
                          }}
                        >
                          View H2H
                        </Link>
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        )}
      </div>
      <H2HBattleList
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        h2hBattleData={h2hBattleData}
        roundDetails={roundDetails}
      />
    </>
  );
};

export default H2hB;
